import React, { useEffect } from 'react';
import VenddiHero from '@/components/venddi/VenddiHero';
import { VenddiProblem, VenddiBenefits } from '@/components/venddi/VenddiBenefits';
import VenddiWow from '@/components/venddi/VenddiWow';
import VenddiKian from '@/components/venddi/VenddiKian';
import { VenddiAplicaciones, VenddiIntegraciones, VenddiCaracteristicas } from '@/components/venddi/VenddiIntegrations';
import VenddiScreenshots from '@/components/venddi/VenddiScreenshots';
import VenddiPlans from '@/components/venddi/VenddiPlans';
import VenddiFAQs from '@/components/venddi/VenddiFAQs';
import VenddiCtaFinal from '@/components/venddi/VenddiCtaFinal';
import { faqSchema, breadcrumb, injectSchema } from '@/lib/schemas';
import { FAQS } from '@/data/venddi';

const VenddiSoftwarePage = () => {
  useEffect(() => {
    injectSchema([
      breadcrumb([
        { name: 'Inicio', path: '/' },
        { name: 'Software', path: '/software' },
        { name: 'Venddi POS', path: '/software/venddi' },
      ]),
      faqSchema(FAQS),
    ]);
  }, []);

  return (
    <div className="bg-white">
      <VenddiHero />
      <VenddiProblem />
      <VenddiBenefits />
      <VenddiWow />
      <VenddiKian />
      <VenddiAplicaciones />
      <VenddiIntegraciones />
      <VenddiCaracteristicas />
      <VenddiScreenshots />
      <VenddiPlans />
      <VenddiFAQs />
      <VenddiCtaFinal />
    </div>
  );
};

export default VenddiSoftwarePage;
